<p-card class="hidden"></p-card>
<p-message class="hidden"></p-message>
<p-blockui [blocked]="loading.show" class="backdrop-blur-xs" />
@if (loading.show) {
  <div
    class="w-screen h-screen flex justify-center items-center loading-spinner fixed"
  >
    <div class="loading-content">
      <p-progress-spinner ariaLabel="loading" />
      @if (loading.message) {
        <div class="loading-message">{{ loading.message }}</div>
      }
    </div>
  </div>
}
<p-toast key="global-toast">
  <ng-template let-message #message>
    <div class="flex flex-col gap-2 w-full">
      <div class="flex gap-2 items-center">
        <i
          class="{{ 'toast.icon' | translate: { type: message.severity } }}"
        ></i>
        <div
          class="font-bold p-toast-summary"
          [innerHTML]="message.summary"
        ></div>
      </div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>
<p-confirmdialog
  [position]="'top'"
  key="global-confirmdialog"
  styleClass="w-[calc(100%_-_1.5rem)] md:max-w-[calc(var(--p-boxed)_-_1.5rem)] mx-auto"
>
  <ng-template let-message #message>
    <div class="flex flex-col gap-2 py-28 px-6">
      <div class="p-confirmdialog-message" [innerHTML]="message.message"></div>
    </div>
  </ng-template>
</p-confirmdialog>

<router-outlet />
